<template>
  <v-app>
    <v-container class="pa-6 ma-0 d-flex flex-column gap-6 align-center main-d">
      <!-- section 1 -->
      <v-container class="pa-0 ma-0">
        <WarehouseFilter
          @apply-filters="HandleApplyFilters"
          @apply-advanced-filters="HandleApplyAdvancedFilters"
        />
        <OverviewWarehouse
          v-if="warehouseData"
          :warehouse-data="warehouseData"
          :total-stock="totalLowStock"
          :duration="changeDurationText"
        />
      </v-container>
      <!--section 2 -->
      <v-container fluid class="pa-0 ma-0">
        <v-row dense>
          <!--list progress -->
          <v-col cols="12" md="6">
            <ProgressListValue :filter-chart="filter" :advance-filter="advancefilter" />
          </v-col>
          <!-- werehouse donate-->
          <v-col cols="12" md="6">
            <DonateWerehouse :filter-chart="filter" :advance-filter="advancefilter" />
          </v-col>
        </v-row>
      </v-container>
      <!--section 3 -->
      <v-container class="pa-0 ma-0">
        <LimitList :filter-chart="filter" :advance-filter="advancefilter" />
      </v-container>
    </v-container>
  </v-app>
</template>

<script>
import WarehouseFilter from "./partial/WarehouseFilter.vue";
import OverviewWarehouse from "./partial/OverviewWarehouse.vue";
import DonateWerehouse from "./partial/DonateWerehouse.vue";
import ProgressListValue from "./partial/ProgressListValue.vue";
import LimitList from "./partial/LimitList.vue";

export default {
  name: "warehouse",
  components: {
    WarehouseFilter,
    OverviewWarehouse,
    DonateWerehouse,
    ProgressListValue,
    LimitList,
  },
  data: () => ({
    warehouseData: null,
    totalLowStock: null,
    loading: false,
    filter: null,
    advancefilter: null,
    changeDurationText: false,
  }),
  mounted() {
    this.getWareHouseData();
    this.getLowStockProducts();
  },
  methods: {
    HandleApplyFilters(filters) {
      this.filter = filters;
      this.getWareHouseData(filters);
    },
    HandleApplyAdvancedFilters(filters) {
      this.advancefilter = filters;
      this.getWareHouseData(filters);
    },
    getWareHouseData(filters = {}) {
      const hasDefaultDate = !!filters.fromDate && !!filters.toDate;
      const Type = hasDefaultDate ? false : "year";
      let UserList = [];
      let ProductList = [];
      if (
        filters.UserList != undefined &&
        filters.UserList != null &&
        filters.UserList != []
      ) {
        UserList = filters?.UserList.map((u) => u.id);
      }
      if (
        filters.products != undefined &&
        filters.products != null &&
        filters.products != []
      ) {
        ProductList = filters?.products.map((p) => p.id);
      }
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "dashboard/invoice-kpi", {
          params: {
            dateType: Type,
            fromDate: filters.fromDate || null,
            toDate: filters.toDate || null,
            status: filters.sellStatus || [],
            accountIds: filters.account || [],
            branch: filters.branch || [],
            UserList: UserList || [],
            minAmount: filters.amountRange?.[0] ?? null,
            maxAmount: filters.amountRange?.[1] ?? null,
            ProductList: ProductList || [],
            productGroup: filters.productGroup || null,
            entrepot: filters.entrepot || null,
            attachment: filters.attachments || null,
            receipt: filters.Receipt || null,
            category: filters.category || null,
            minAmountTax: filters.amountRangeTax?.[0] ?? null,
            maxAmountTax: filters.amountRangeTax?.[1] ?? null,
            invoice_status: filters.status || null,
          },
        })
        .then((response) => {
          let res = response.data;
          app.warehouseData = res.EntrepotSummary;
          app.changeDurationText = res.flag;
        })
        .catch((err) => {
          app.loading = false;
        })
        .finally(() => {
          app.loading = false;
        });
    },
    getLowStockProducts(filters = {}) {
      const hasDefaultDate = !!filters.fromDate && !!filters.toDate;
      const Type = hasDefaultDate ? false : "year";
      let UserList = [];
      let ProductList = [];
      if (
        filters.UserList != undefined &&
        filters.UserList != null &&
        filters.UserList != []
      ) {
        UserList = filters?.UserList.map((u) => u.id);
      }
      if (
        filters.products != undefined &&
        filters.products != null &&
        filters.products != []
      ) {
        ProductList = filters?.products.map((p) => p.id);
      }
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "dashboard/charts/product-in-order-point", {
          params: {
            dateType: "year",
          },
        })
        .then((response) => {
          console.log(response, "low stock___");
          let res = response.data.data;
          app.totalLowStock = res.reduce((sum, item) => {
            return sum + (Number(item.stock) || 0);
          }, 0);
          console.log(typeof app.totalLowStock, "smjdnjkashkjdkasndnnssa");
        })
        .catch((err) => {
          app.loading = false;
        })
        .finally(() => {
          app.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.main-d {
  min-width: 400px !important;
}
</style>
